import React from "react";
import style from "../../styles/card.module.scss";

export const Card = ({ img, header, desc }) => {
  return (
    <div className={style.card}>
      <img src={img} alt="Card Img" />
      <h4>{header}</h4>
      <p>{desc}</p>
    </div>
  );
};


